import { Api } from 'utils';

class ChatService {
  static get = async (params = {}) => Api.createResponse('app/chat', params);
  static save = async (params = {}) => Api.createResponse('app/chat/save', params);
  static send = async (params = {}) => Api.createResponse('app/chat/send', params);
  static getAreas = async (params = {}) => Api.createResponse('app/chat/areas', params);
  static view = async (params = {}) => Api.createResponse('app/chat/view', params);
  static resolvedChatCall = async (params = {}) => Api.createResponse('app/chat/resolved', params);
  static resolvedChat = async (params = {}) => Api.createResponse('app/chat/resolved-chat', params);
  static getCalls = async (params = {}) => Api.createResponse('app/chat/calls', params);
  static update = async (params = {}) => Api.createResponse('app/chat/update', params);
  static findOne = async (params = {}) => Api.createResponse('app/chat/get-one', params);

  static admin = {
    get: async (params?: any) => Api.createResponse('admin/chats/', params),
    view: async (params?: any) => Api.createResponse('admin/chats/view', params),
    payment: async (params?: any) => Api.createResponse('admin/chats/payment', params),
    // Reemplaza el uso previo (incorrecto) de RevisionService.admin.getLawyers/
    // assignLawyer desde screens/admin/chat -- ese endpoint filtraba por
    // UserServicePrice de Revisión (con un document_id hardcodeado a 5, ya que
    // Chat no tiene documentos) en vez de por la elegibilidad real de Chat
    // (UserArea.with_chat = true). Ver conversación del backend.
    getLawyers: async (params?: any) => Api.createResponse('admin/chats/lawyers', params),
    assignLawyer: async (params?: any) => Api.createResponse('admin/chats/assignLawyer', params),
  };
}

export default ChatService;
